import * as RxRadioGroup from "@radix-ui/react-radio-group";
import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";

type RootProps<T extends string> = {
  className?: string;
  style?: React.CSSProperties;
  value: T;
  onChange?: (value: T) => void;
  allowedValues: T[];
  content?: React.ReactNode;
  children?: React.ReactNode;
};

function Root<T extends string>({
  className,
  style,
  value,
  onChange,
  allowedValues,
  content,
  children = content,
}: RootProps<T>) {
  const handleValueChange = (text: string) => {
    const value = allowedValues.find((item) => item === text);
    value !== undefined && onChange?.(value);
  };

  return (
    <RxRadioGroup.Root
      className={cx(styles.root, className)}
      style={style}
      value={value}
      onValueChange={handleValueChange}
    >
      {children}
    </RxRadioGroup.Root>
  );
}

type ItemProps = {
  className?: string;
  style?: React.CSSProperties;
  value: string;
  content?: React.ReactNode;
  children?: React.ReactNode;
};

function Item({
  className,
  style,
  value,
  content,
  children = content,
}: ItemProps) {
  return (
    <label className={cx(styles.item, className)} style={style}>
      <RxRadioGroup.Item className={styles.radio} value={value}>
        <RxRadioGroup.Indicator className={styles.radioIndicator} />
      </RxRadioGroup.Item>
      <span>{children}</span>
    </label>
  );
}

const RadioGroup = { Root, Item };

export default RadioGroup;
